var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: {
        name: "qr-modal",
        width: "sm",
        title: _vm.$t("otp_enable_title"),
        autofocus: _vm.$refs.verificationCode
      },
      on: { hide: _vm.handleClose },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c(
            "q-stepper",
            { ref: "tfaStepper" },
            [
              _c(
                "q-step",
                { attrs: { default: "", title: "setup" } },
                [
                  _c("p", [_vm._v(_vm._s(_vm.$t("otp_enable_body")))]),
                  _c("div", {
                    staticClass: "qr-modal__image row justify-center",
                    domProps: { innerHTML: _vm._s(_vm.qrImage) }
                  }),
                  _c(
                    "i18n",
                    {
                      staticClass: "text-faded mt-1",
                      attrs: { tag: "p", path: "otp_enable_hint" }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "primary-link",
                          attrs: { place: "manualSetup", href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.handleManualSetup($event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("otp_enable_manual")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm.manualSetup
                    ? _c("div", { staticClass: "qr-modal__code_area" }, [
                        _c("table", [
                          _c("tr", [
                            _c("td", { staticClass: "text-bold" }, [
                              _vm._v(_vm._s(_vm.$t("algorithm")) + ":")
                            ]),
                            _c("td", [_vm._v("SHA1")])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "text-bold" }, [
                              _vm._v(_vm._s(_vm.$t("digits")) + ":")
                            ]),
                            _c("td", [_vm._v("6")])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "text-bold" }, [
                              _vm._v(_vm._s(_vm.$t("mode")) + ":")
                            ]),
                            _c("td", [_vm._v("TOTP")])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "text-bold" }, [
                              _vm._v(_vm._s(_vm.$t("interval")) + ":")
                            ]),
                            _c("td", [
                              _vm._v("30 " + _vm._s(_vm.$tc("second", 2)))
                            ])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "text-bold" }, [
                              _vm._v(_vm._s(_vm.$t("secret")) + ":")
                            ]),
                            _c("td", [_vm._v(_vm._s(_vm.setupSecret))])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "q-mt-lg row justify-between items-end" },
                    [
                      _c("q-input", {
                        ref: "verificationCode",
                        staticClass: "qr-modal__input inline",
                        attrs: { placeholder: "OTP Code" },
                        model: {
                          value: _vm.verificationCode,
                          callback: function($$v) {
                            _vm.verificationCode = $$v
                          },
                          expression: "verificationCode"
                        }
                      }),
                      _c(
                        "q-btn",
                        {
                          staticClass: "inline on-right",
                          attrs: { color: "positive" },
                          on: { click: _vm.handleVerify }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("confirm")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-step",
                { attrs: { title: "backup" } },
                [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.$t("backup_codes_body")) }
                  }),
                  _c("backup-codes-area", {
                    staticClass: "q-mt-lg",
                    attrs: { "backup-codes": _vm.backupCodes }
                  }),
                  _c(
                    "q-btn",
                    {
                      staticClass: "full-width q-mt-lg",
                      attrs: { color: "positive" },
                      on: { click: _vm.handleClose }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("confirm")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _c("q-inner-loading", { attrs: { visible: _vm.loading } })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }